module.exports = __webpack_public_path__ + "img/icon_tab_favorite.2d63699c.png";